// @ts-nocheck
import * as _ from "lodash"
import AccesoServicios from "../services/AccesoServicios"
import { $unibase, IUniConfig } from "../uni-base-module"

const _defaultDelay = 1000

export interface UniStoreFactory {
  new(
    endpoint,
    errorMsg,
    localStorageConfig,
    keybyComparator,
    listKeyComparator
  ): UniStore
}

export class UniStore {
  private _keyby: string | Function
  private resource: any
  private leido: boolean

  data: {
    map: {}
    list: any[]
  }

  constructor(
    private endpoint,
    errorMsg,
    private localStorageConfig,
    keybyComparator: string | Function,
    private listKeyComparator: string,
    private $log: ng.ILogService,
    private $resource: ng.resource.IResourceService,
    private AccesoServicios: AccesoServicios,
    private localStorageService,
    private UniConfig: IUniConfig
  ) {
    this._keyby = keybyComparator
    this.resource = $resource(
      UniConfig.urlServiciosProg + endpoint,
      {},
      AccesoServicios.defaults(errorMsg)
    )

    this.leido = false
  }

  load(forzarServidor) {
    this.loadStore.call(this, forzarServidor)
  }

  loadServidor() {
    return this.resource.query(serverData => {
      // si keybyComparator es una función, usarla para generar el data
      if (typeof this._keyby === "function") {
        console.log("Generar data de store con funcion")

        this.data = this._keyby(serverData)
      } else {
        // generar un data clasificando datos con el keybyComparator si existe, y
        // guarda el resultado en un list

        this.data = {
          map: {},
          list: []
        }

        if (this._keyby) {
          // generar lista
          if (this.listKeyComparator)
            this.data.map = _.keyBy(serverData, this.listKeyComparator)
          else this.data.map = _.keyBy(serverData, this._keyby)
        }

        this.data.list = serverData
      }

      // guardar en el localStorage si está activo
      if (this.UniConfig.useLocalStorage && this.localStorageConfig.activo) {
        this.localStorageService.set(this.localStorageConfig.key, this.data)
      }

      this.leido = true
    }).$promise
  }

  loadStore(cargaServidor) {
    var _store = this

    if (cargaServidor)
      // forzar lectura
      return this.loadServidor.call(this)
    else if (!this.leido) {
      // intentar leer datos de localstorage
      var datos
      if (this.UniConfig.useLocalStorage && this.localStorageConfig.activo) {
        datos = this.localStorageService.get(this.localStorageConfig.key)
      }

      if (datos) {
        // los datos están en localStorage, guay
        // _store.data.map = datos.map;
        // _store.data.list = datos.list;

        _store.data = datos
      } else {
        this.loadServidor.call(this)
      }
    } else {
      // ya leído !
      console.log(
        "Volviendo a hacer load de datos ya leídos del store " + this.endpoint,
        _store
      )
    }
  }
}

/*
    function cargarDatosServidor(callback) {

        initClinicasStore();

        _resourceClinicas.query(function (list) {
            $log.debug(list);

            _store.clinicasList = list;

            // obtener los centros
            _.each(_store.clinicasList, function (clinica) {

                // nombre
                setNombreClinica(clinica);

                // dict de clinicas
                _store.clinicas[clinica.idclinica] = clinica;

                if (clinica.idcentro && !_store.centros[clinica.idcentro]) {
                    _store.centros[clinica.idcentro] = clinica.centro;
                    _store.centrosList.push(clinica.centro);
                }
            });

            // guardar datos en localStorage
            if (UniConfig.useLocalStorage && UniConfig.clinicasKey.activo)
                this.localStorageService.set(UniConfig.clinicasKey.key, _store);

            callback(_store);
        });
    }
    */

$unibase.factory(
  "UniStore",
  ($log, $resource, AccesoServicios, localStorageService, UniConfig) => (
    endpoint,
    errorMsg,
    localStorageConfig,
    keybyComparator,
    listKeyComparator
  ) =>
    new UniStore(
      endpoint,
      errorMsg,
      localStorageConfig,
      keybyComparator,
      listKeyComparator,
      $log,
      $resource,
      AccesoServicios,
      localStorageService,
      UniConfig
    )
)
